import { useQuery } from '@tanstack/react-query'
import { isAxiosError } from 'axios'

import { GetAtendimentoAtivoService } from '@/features/atendimento/shared/http'
import { useLocalStorage } from '@/hooks'
import type { TAtendimento } from '@/types/atendimento'
import { atendimentoKeys } from '@/utils/atendimento-query-keys'

export const useAtendimentoAtivo = (enabled: boolean) => {
  const [_, setAtendimentoAtivo] = useLocalStorage<TAtendimento | null>('atendimento', null)
  return useQuery({
    queryKey: atendimentoKeys.atendimentoAtivo(),
    queryFn: async () => {
      try {
        const response = await new GetAtendimentoAtivoService().execute()
        setAtendimentoAtivo(response)
        return response
      } catch (error) {
        if (isAxiosError(error) && error.response?.status === 404) {
          return null
        }
        throw error
      }
    },
    retry: false,
    enabled,
  })
}
